import { render, staticRenderFns } from "./AppSnackbar.vue?vue&type=template&id=15e05881"
import script from "./AppSnackbar.vue?vue&type=script&lang=ts"
export * from "./AppSnackbar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports